<template>
  <div class="btn-bottom-margin">
    <h1 class="header-style">
      Schedule
    </h1>
    <div>
      <v-tabs
        v-model="tab"
        class="tab-style mt-5"
        rounded
        color="transparent"
        active-class="selected-tab"
        light
      >
        <v-tab
          class="tab-accepted"
        >
          <v-icon size="15">
            mdi-check-circle-outline
          </v-icon> Accepted
        </v-tab>
        <v-tab
          class="tab-pending"
        >
          <v-icon size="15">
            mdi-clock-outline
          </v-icon> Pending
        </v-tab>
      </v-tabs>
      <v-tabs-items
        v-model="tab"
        class="my-tabs-background-style"
        touchless
      >
        <v-tab-item>
          <v-card-text>
            <jobs-accepted />
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <jobs-pending />
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
      <br>
      <br>
    </div>
  </div>
</template>
<script>
import JobsAccepted from './dialogComponents/JobsDialogs/JobsAccepted.vue';
import JobsPending from './dialogComponents/JobsDialogs/JobsPending.vue';
export default {
  name: 'JobsPage',
  components: {
    'jobs-accepted': JobsAccepted,
    'jobs-pending': JobsPending,
  },
  data: () => ({
    tab: null,
  }),
  watch: {
    tab (newVal) {
      this.$store.dispatch('jobs/storeJobFilters', {});
    },
  },
};
</script>
<style scoped>
.from-style {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.my-tabs-background-style {
  background-color: transparent;
}

.v-item-group
  theme--dark
  v-slide-group
  v-tabs-bar
  v-tabs-bar--is-mobile
  primary--text {
  width: 100%;
}

.v-slide-group__content v-tabs-bar__content {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.v-tabs-slider-wrapper {
  background-color: transparent !important;
}

.v-tab {
  color: #000000 !important;
  border-radius: 10px;
  height: 30px;
  margin-top: 10px;
  margin-right: 10px;
  display: flex;
  gap: 10px;
  background: #FFF;
}

.v-tab.tab-pending {
  width: 40% !important;
  border: 1px solid #ffca68;
}

.v-tab--active.tab-pending {
  color: #ffffff !important;
  background: #ffca68;
  border: none;
}

.v-tab.tab-accepted {
  width: 40% !important;
  border: 1px solid #63ca7f;
}

.v-tab--active.tab-accepted {
  color: #ffffff !important;
  background: #63ca7f;
  border: none;
}

.selected-tab {
  color: #fff;
}

.v-tab {
  font-size: 12px !important;
}

.v-card__text {
  padding: 0px !important;
}
</style>
